<template>
  <div id="preventPollution">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>监控中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/UrlMonitor' }">单链接监控</el-breadcrumb-item>
        <el-breadcrumb-item>变更历史</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <div class="block">
        <span class="demonstration" style="margin-right: 10px;">变更时间</span>
        <el-date-picker
        v-model="searchformDate"
        size="small"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        range-separator="~"
        :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <el-timeline style="margin-left: 26px;margin-top: 35px;">
        <el-timeline-item  :timestamp="item.changetime | formatDate" placement="top" v-for="item in tableData">
          <div style="color: #c6c6c6;margin-bottom: 20px;margin-top: 20px;">变更人:{{item.realname}}</div>
          <el-card style="margin-bottom: 20px;" v-show="item.changeMessage == '修改' && item.contentBefore != ''">
            <div class="beforeChange">
              变更前
            </div>
            <div style="width: 90%;word-wrap: break-word;word-break: normal;">
              {{item.contentBefore}}
            </div>
          </el-card>

          <el-card style="margin-bottom: 20px;" v-show="item.changeMessage == '修改' && item.contentAfter != ''">
            <div class="afterChange">
              变更后
            </div>
            <div style="width: 90%;word-wrap: break-word;word-break: normal;">
              {{item.contentAfter}}
            </div>
          </el-card>

          <el-card style="margin-bottom: 20px;" v-show="item.changeMessage == '新增'">
            <div class="newAdd">
              新增
            </div>
            <div style="width: 90%;word-wrap: break-word;word-break: normal;">
              {{item.contentAfter}}
            </div>
          </el-card>

          <el-card style="margin-bottom: 20px;" v-show="item.changeMessage == '删除'">
            <div class="newdelete">
              删除
            </div>
            <div style="width: 90%;word-wrap: break-word;word-break: normal;">
              {{item.contentAfter}}
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div style="width: 100%;text-align: center;">
        <el-button v-show="loadMore" @click="loadMoreBtn" plain>加载更多</el-button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        tableData: [],
        searchformDate: [],
        pickerOptions: {
  				shortcuts: [{
  					text: '最近三个月',
  					onClick:(picker) => {
  						this.getRecentDate(picker);
  					}
  				}]
  			},
        loadMore: false,
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    created(){
  		this.getRecentDate();
  	},
    mounted() {
      this.oneStep();
    },
    methods: {
      // 前三个月时间
  		getRecentDate(picker){
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
  		},
      loadMoreBtn() {
        this.pageNum++
        this.oneStep(this.pageNum)
      },
      oneStep() {
        let params={
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          modulename: 'MonitorLink',
          begintime: this.$options.filters['fullTime'] (this.searchformDate[0]),
          endtime: this.$options.filters['fullTime'] (this.searchformDate[1]),
          objectid: this.$route.query.itemid
        }
        fetch({
          url: "hcm/hcmChangeHistory/getList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data;
            if (this.tableData.length == 10) {
              this.loadMore = true
            }
          } else if (res.status == '10400') {

          }
        })
        .catch(err => {

        })
      },

    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .beforeChange {
    width: 110px;
    margin-right: 10px;
    height: 35px;
    background-color: #fffbf3;
    text-align: center;
    line-height: 35px;
    color: #fab332;
  }
  .afterChange {
    width: 110px;
    margin-right: 10px;
    height: 35px;
    background-color: #f3f9fe;
    text-align: center;
    line-height: 35px;
    color: #108cee;
  }
  .newAdd {
    width: 110px;
    margin-right: 10px;
    height: 35px;
    background-color: #f6fcf3;
    text-align: center;
    line-height: 35px;
    color: #a0db8c;
  }
  .newdelete {
    width: 110px;
    margin-right: 10px;
    height: 35px;
    background-color: #fef4f5;
    text-align: center;
    line-height: 35px;
    color: #e90e24;
  }

</style>
<style lang="scss">
#preventPollution {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-card__body {
    display: flex;
  }
  .el-button {
    width: 420px;
    border: 1px dashed #DCDFE6;
  }
}
</style>
